/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_Err_GenericInputs */

const en_st_wl_err_generic = /** @type {(inputs: St_Wl_Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send. Try again.`)
};

const id_st_wl_err_generic = /** @type {(inputs: St_Wl_Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mengirim. Coba lagi.`)
};

/**
* | output |
* | --- |
* | "Could not send. Try again." |
*
* @param {St_Wl_Err_GenericInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_err_generic = /** @type {((inputs?: St_Wl_Err_GenericInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_Err_GenericInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_err_generic(inputs)
	return en_st_wl_err_generic(inputs)
});